import { useMemo } from 'react'

import {
  DocumentRequest,
  ResolveSourceDisplayNamesRequest,
} from '@trustero/trustero-api-web/lib/request/request_pb'
import { RequestPromiseClient } from '@trustero/trustero-api-web/lib/request/request_grpc_web_pb'

import { useSwrGrpc } from 'src/components/async/useSwrGrpc'

export const useResolveSourceDisplayNames = (
  requests: DocumentRequest[],
): Map<string, string> => {
  const sources = useMemo(() => {
    const unique = new Set<string>()
    requests.forEach((r) => {
      const src = r.getSource()
      if (src) unique.add(src)
    })
    return [...unique].sort()
  }, [requests])

  const req = useMemo(() => {
    const r = new ResolveSourceDisplayNamesRequest()
    r.setSourcesList(sources)
    return r
  }, [sources])

  const { response } = useSwrGrpc(
    RequestPromiseClient.prototype.resolveSourceDisplayNames,
    req,
    sources.length > 0,
    { revalidateOnFocus: false },
  )

  return useMemo(() => {
    const map = new Map<string, string>()
    response.data
      ?.getDisplayNamesMap()
      .forEach((value: string, key: string) => {
        map.set(key, value)
      })
    return map
  }, [response.data])
}
